import React from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";


export default function BusinessProfile() {


    const { slug } = useParams();

    const businessTitle = slug
        ? slug
            .split("-")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")
        : "";


    if (!businessTitle) {
        return <div className="text-center mt-5">Business not found</div>;
    }
    return (
        <>
            <Helmet>
                {/* Favicons */}
                <link rel="icon" href="/assets/img/favicon.png" />
                <link rel="apple-touch-icon" href="/assets/img/apple-touch-icon.png" />

                {/* Fonts */}
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Jost:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
                    rel="stylesheet"
                />

                {/* Vendor CSS */}
                <link rel="stylesheet" href="/business/assets/vendor/bootstrap/css/bootstrap.min.css" />
                <link rel="stylesheet" href="/business/assets/vendor/bootstrap-icons/bootstrap-icons.css" />
                <link rel="stylesheet" href="/business/assets/vendor/aos/aos.css" />
                <link rel="stylesheet" href="/business/assets/vendor/glightbox/css/glightbox.min.css" />
                <link rel="stylesheet" href="/business/assets/vendor/swiper/swiper-bundle.min.css" />
                {/* Main CSS */}
                <script src="/business/assets/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
                <script src="/business/assets/vendor/php-email-form/validate.js"></script>
                <script src="/business/assets/vendor/aos/aos.js"></script>
                <script src="/business/assets/vendor/glightbox/js/glightbox.min.js"></script>
                <script src="/business/assets/vendor/swiper/swiper-bundle.min.js"></script>
                <script src="/business/assets/vendor/waypoints/noframework.waypoints.js"></script>
                <script src="/business/assets/vendor/imagesloaded/imagesloaded.pkgd.min.js"></script>
                <script src="/business/assets/vendor/isotope-layout/isotope.pkgd.min.js"></script>
                <script src="/business/assets/js/main.js"></script>
                <link rel="stylesheet" href="/business/assets/css/main.css" />
            </Helmet>


            {/* ================= HEADER ================= */}
            <header id="header" className="header d-flex align-items-center fixed-top">
                <div className="container-fluid container-xl position-relative d-flex align-items-center">

                    <a href="index.html" className="logo d-flex align-items-center me-auto">


                        <h3
                            className="sitename"
                            style={{
                                fontFamily: "'Poppins', sans-serif",
                                color: "#ffc107bf",
                                fontWeight: 400
                            }}
                        >
                            {businessTitle}
                        </h3>



                    </a>

                    <nav id="navmenu" className="navmenu">
                        <ul>
                            <li><a href="#hero" className="active">Home</a></li>
                            <li><a href="#about">About</a></li>
                            <li><a href="#services">Services</a></li>
                            <li><a href="#portfolio">Portfolio</a></li>


                            <li><a href="#contact">Contact</a></li>
                        </ul>

                        <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
                    </nav>



                </div>
            </header>
            {/* ================= END HEADER ================= */}
            <main className="main">

                {/* Hero Section */}
                <section id="hero" className="hero section dark-background">

                    <div className="container">
                        <div className="row gy-4">
                            <div
                                className="col-lg-6 order-2 order-lg-1 d-flex flex-column justify-content-center"
                                data-aos="zoom-out"
                            >
                                <h1>Better Solutions For Your Business</h1>
                                <p>We are team of talented designers making websites with Bootstrap</p>
                                <div className="d-flex">
                                    <a href="#about" className="btn-get-started">Get Started</a>
                                    <a
                                        href="https://www.youtube.com/watch?v=Y7f98aduVJ8"
                                        className="glightbox btn-watch-video d-flex align-items-center"
                                    >
                                        <i className="bi bi-play-circle"></i>
                                        <span>Watch Video</span>
                                    </a>
                                </div>
                            </div>

                            <div
                                className="col-lg-6 order-1 order-lg-2 hero-img"
                                data-aos="zoom-out"
                                data-aos-delay="200"
                            >
                                <img
                                    src="/assets/img/hero-img.png"
                                    className="img-fluid animated"
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>

                </section>
                {/* /Hero Section */}


                {/* ================= ABOUT BUSINESS SECTION ================= */}
                <section id="about" className="about section py-5 bg-light">

                    <div className="container">

                        {/* Section Header */}
                        <div className="row mb-4">
                            <div className="col text-center">
                                <h2 className="fw-bold">About This Business</h2>
                                <p className="text-muted mt-2">
                                    Get to know more about the business and what they offer
                                </p>
                            </div>
                        </div>

                        {/* Content */}
                        <div className="row justify-content-center">

                            <div className="col-lg-12">

                                <div className="card border-0 shadow-sm">
                                    <div className="card-body p-4 p-lg-5">

                                        {/* Business Description */}
                                        <h4 className="fw-semibold mb-3">
                                            Business Overview
                                        </h4>

                                        <p className="text-muted mb-4">
                                            This business provides reliable and professional services
                                            with a strong focus on quality, customer satisfaction, and
                                            long-term relationships. Their goal is to deliver solutions
                                            that meet real customer needs in a timely and transparent manner.
                                        </p>

                                        {/* Key Highlights */}
                                        <div className="row gy-3 mb-4">

                                            <div className="col-md-6">
                                                <div className="d-flex align-items-start">
                                                    <i className="bi bi-briefcase fs-5 text-primary me-3"></i>
                                                    <div>
                                                        <h6 className="mb-1">Services Offered</h6>
                                                        <p className="mb-0 text-muted">
                                                            Professional and customized services tailored to client requirements
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="d-flex align-items-start">
                                                    <i className="bi bi-people fs-5 text-primary me-3"></i>
                                                    <div>
                                                        <h6 className="mb-1">Client Focus</h6>
                                                        <p className="mb-0 text-muted">
                                                            Clear communication and customer-first approach
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="d-flex align-items-start">
                                                    <i className="bi bi-award fs-5 text-primary me-3"></i>
                                                    <div>
                                                        <h6 className="mb-1">Quality Commitment</h6>
                                                        <p className="mb-0 text-muted">
                                                            High standards and consistent service delivery
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="d-flex align-items-start">
                                                    <i className="bi bi-clock-history fs-5 text-primary me-3"></i>
                                                    <div>
                                                        <h6 className="mb-1">Timely Execution</h6>
                                                        <p className="mb-0 text-muted">
                                                            On-time delivery with transparent processes
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        {/* Additional Info */}
                                        <div className="border-top pt-3">
                                            <p className="mb-0 text-muted">
                                                For more details about their services, availability, or
                                                customized solutions, feel free to reach out directly
                                                through the contact section below.
                                            </p>
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </section>
                {/* ================= END ABOUT BUSINESS SECTION ================= */}






                {/* Services Section */}
                <section id="services" className="services section light-background">

                    {/* Section Title */}
                    <div className="container section-title" data-aos="fade-up">
                        <h2>Services</h2>
                        <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p>
                    </div>
                    {/* End Section Title */}

                    <div className="container">

                        <div className="row gy-4">

                            <div
                                className="col-xl-3 col-md-6 d-flex"
                                data-aos="fade-up"
                                data-aos-delay="100"
                            >
                                <div className="service-item position-relative">
                                    <div className="icon">
                                        <i className="bi bi-activity icon"></i>
                                    </div>
                                    <h4>
                                        <a href="" className="stretched-link">Lorem Ipsum</a>
                                    </h4>
                                    <p>Voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi</p>
                                </div>
                            </div>
                            {/* End Service Item */}

                            <div
                                className="col-xl-3 col-md-6 d-flex"
                                data-aos="fade-up"
                                data-aos-delay="200"
                            >
                                <div className="service-item position-relative">
                                    <div className="icon">
                                        <i className="bi bi-bounding-box-circles icon"></i>
                                    </div>
                                    <h4>
                                        <a href="" className="stretched-link">Sed ut perspici</a>
                                    </h4>
                                    <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore</p>
                                </div>
                            </div>
                            {/* End Service Item */}

                            <div
                                className="col-xl-3 col-md-6 d-flex"
                                data-aos="fade-up"
                                data-aos-delay="300"
                            >
                                <div className="service-item position-relative">
                                    <div className="icon">
                                        <i className="bi bi-calendar4-week icon"></i>
                                    </div>
                                    <h4>
                                        <a href="" className="stretched-link">Magni Dolores</a>
                                    </h4>
                                    <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia</p>
                                </div>
                            </div>
                            {/* End Service Item */}

                            <div
                                className="col-xl-3 col-md-6 d-flex"
                                data-aos="fade-up"
                                data-aos-delay="400"
                            >
                                <div className="service-item position-relative">
                                    <div className="icon">
                                        <i className="bi bi-broadcast icon"></i>
                                    </div>
                                    <h4>
                                        <a href="" className="stretched-link">Nemo Enim</a>
                                    </h4>
                                    <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis</p>
                                </div>
                            </div>
                            {/* End Service Item */}

                        </div>

                    </div>

                </section>
                {/* /Services Section */}



                {/* Call To Action Section */}
                <section id="call-to-action" className="call-to-action section dark-background">

                    <img src="/assets/img/bg/bg-8.webp" alt="" />

                    <div className="container">

                        <div className="row" data-aos="zoom-in" data-aos-delay="100">
                            <div className="col-xl-9 text-center text-xl-start">
                                <h3>Call To Action</h3>
                                <p>
                                    Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                                    Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                                </p>
                            </div>
                            <div className="col-xl-3 cta-btn-container text-center">
                                <a className="cta-btn align-middle" href="#">Call To Action</a>
                            </div>
                        </div>

                    </div>

                </section>
                {/* /Call To Action Section */}


                {/* ================= PORTFOLIO SECTION ================= */}
                <section id="portfolio" className="portfolio section">

                    {/* Section Title */}
                    <div className="container section-title" data-aos="fade-up">
                        <h2>Portfolio</h2>
                        <p>Photos, videos and work samples from our business</p>
                    </div>
                    {/* End Section Title */}

                    <div className="container">

                        {/* Tabs */}
                        <ul className="nav nav-pills justify-content-center mb-4" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link active"
                                    id="photos-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#photos"
                                    type="button"
                                    role="tab"
                                >
                                    Photos
                                </button>
                            </li>

                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link"
                                    id="videos-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#videos"
                                    type="button"
                                    role="tab"
                                >
                                    Videos
                                </button>
                            </li>

                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link"
                                    id="projects-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#projects"
                                    type="button"
                                    role="tab"
                                >
                                    Projects
                                </button>
                            </li>
                        </ul>

                        {/* Tabs Content */}
                        <div className="tab-content">

                            {/* ================= PHOTOS TAB ================= */}
                            <div
                                className="tab-pane fade show active"
                                id="photos"
                                role="tabpanel"
                            >
                                <div className="row gy-4">

                                    <div className="col-lg-4 col-md-6">
                                        <img
                                            src="/assets/img/portfolio/portfolio-1.webp"
                                            className="img-fluid rounded"
                                            alt=""
                                        />
                                    </div>

                                    <div className="col-lg-4 col-md-6">
                                        <img
                                            src="/assets/img/portfolio/portfolio-3.webp"
                                            className="img-fluid rounded"
                                            alt=""
                                        />
                                    </div>

                                    <div className="col-lg-4 col-md-6">
                                        <img
                                            src="/assets/img/portfolio/portfolio-4.webp"
                                            className="img-fluid rounded"
                                            alt=""
                                        />
                                    </div>

                                </div>
                            </div>

                            {/* ================= VIDEOS TAB ================= */}
                            <div
                                className="tab-pane fade"
                                id="videos"
                                role="tabpanel"
                            >
                                <div className="row gy-4 justify-content-center">

                                    <div className="col-lg-6">
                                        <div className="ratio ratio-16x9">
                                            <iframe
                                                src="https://www.youtube.com/embed/Y7f98aduVJ8"
                                                title="Business Video"
                                                allowFullScreen
                                            ></iframe>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {/* ================= PROJECTS TAB ================= */}
                            <div
                                className="tab-pane fade"
                                id="projects"
                                role="tabpanel"
                            >
                                <div className="row gy-4">

                                    <div className="col-lg-4 col-md-6">
                                        <div className="card h-100 shadow-sm">
                                            <div className="card-body">
                                                <h5 className="card-title">Website Development</h5>
                                                <p className="card-text">
                                                    Corporate website designed and developed using modern technologies.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-4 col-md-6">
                                        <div className="card h-100 shadow-sm">
                                            <div className="card-body">
                                                <h5 className="card-title">Mobile Application</h5>
                                                <p className="card-text">
                                                    Android and iOS mobile app for business operations.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-4 col-md-6">
                                        <div className="card h-100 shadow-sm">
                                            <div className="card-body">
                                                <h5 className="card-title">Digital Marketing</h5>
                                                <p className="card-text">
                                                    SEO, social media marketing and online brand promotion.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>

                </section>
                {/* ================= END PORTFOLIO SECTION ================= */}



                {/* Contact Section */}
                <section id="contact" className="contact section">

                    <div className="container section-title" data-aos="fade-up">
                        <h2>Contact</h2>
                        <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p>
                    </div>

                    <div className="container" data-aos="fade-up" data-aos-delay="100">

                        <div className="row gy-4">

                            <div className="col-lg-12">

                                <div className="row info-wrap">

                                    <div className="col info-item d-flex" data-aos="fade-up" data-aos-delay="200">
                                        <i className="bi bi-geo-alt flex-shrink-0"></i>
                                        <div>
                                            <h3>Address</h3>
                                            <p>A108 Adam Street, New York, NY 535022</p>
                                        </div>
                                    </div>

                                    <div className="col info-item d-flex" data-aos="fade-up" data-aos-delay="300">
                                        <i className="bi bi-telephone flex-shrink-0"></i>
                                        <div>
                                            <h3>Call Us</h3>
                                            <p>+1 5589 55488 55</p>
                                        </div>
                                    </div>

                                    <div className="col info-item d-flex" data-aos="fade-up" data-aos-delay="400">
                                        <i className="bi bi-envelope flex-shrink-0"></i>
                                        <div>
                                            <h3>Email Us</h3>
                                            <p>info@example.com</p>
                                        </div>
                                    </div>

                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d48389.78314118045!2d-74.006138!3d40.710059!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a22a3bda30d%3A0xb89d1fe6bc499443!2sDowntown%20Conference%20Center!5e0!3m2!1sen!2sus!4v1676961268712!5m2!1sen!2sus"
                                        style={{ border: 0, width: "100%", height: "270px" }}
                                        allowFullScreen
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        title="map"
                                    ></iframe>

                                </div>
                            </div>



                        </div>

                    </div>

                </section>
                {/* /Contact Section */}


                {/* Footer */}
                <footer id="footer" className="footer bg-light pt-5">

                    <div className="container">
                        <div className="row gy-4">

                            {/* Brand / About */}
                            <div className="col-lg-6 col-md-6">
                                <h5 className="mb-3">Dial Nepal</h5>
                                <p className="mb-2">
                                    Dial Nepal is a trusted business directory helping users discover <br></br>
                                    local businesses, services, and professionals across Nepal.
                                </p>
                                <p className="mb-0">
                                    <strong>Email:</strong> support@dialnepal.com<br />
                                    <strong>Phone:</strong> +977 98XXXXXXXX
                                </p>
                            </div>

                            {/* Useful Links */}
                            <div className="col-lg-3 col-md-6">
                                <h6 className="mb-3">Quick Links</h6>
                                <ul className="list-unstyled">
                                    <li className="mb-2"><a href="/" className="text-decoration-none">Home</a></li>
                                    <li className="mb-2"><a href="/about" className="text-decoration-none">About Us</a></li>
                                    <li className="mb-2"><a href="/categories" className="text-decoration-none">Categories</a></li>
                                    <li className="mb-2"><a href="/contact" className="text-decoration-none">Contact</a></li>
                                </ul>
                            </div>



                            {/* Social */}
                            <div className="col-lg-3 col-md-6">
                                <h6 className="mb-3">Follow Us</h6>
                                <p className="mb-3">Stay connected with us on social platforms.</p>
                                <div className="d-flex gap-3">
                                    <a href="#" className="text-decoration-none fs-5">
                                        <i className="bi bi-facebook"></i>
                                    </a>
                                    <a href="#" className="text-decoration-none fs-5">
                                        <i className="bi bi-instagram"></i>
                                    </a>
                                    <a href="#" className="text-decoration-none fs-5">
                                        <i className="bi bi-linkedin"></i>
                                    </a>
                                    <a href="#" className="text-decoration-none fs-5">
                                        <i className="bi bi-twitter-x"></i>
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* Bottom Bar */}
                    <div className="container mt-4 pt-3 border-top text-center">
                        <p className="mb-1">
                            © {new Date().getFullYear()}{" "}
                            <strong className="sitename">Dial Nepal</strong>. All Rights Reserved.
                        </p>
                        <small>
                            Designed & Developed by Dial Nepal Pvt Ltd
                        </small>
                    </div>

                </footer>

                {/* Scroll Top */}
                <a
                    href="#"
                    id="scroll-top"
                    className="scroll-top d-flex align-items-center justify-content-center"
                >
                    <i className="bi bi-arrow-up-short"></i>
                </a>

                {/* Preloader */}
                <div id="preloader"></div>




            </main>


        </>
    );
}
